import { Command } from '@nest/internal-frontend';
import { HistoryIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useNumberParam } from '../../../helpers';

export const useCommandGoToCompletedConsignmentNotes = (): Command => {
	const navigate = useNavigate();
	const carrierId = useNumberParam('carrierId');

	return {
		id: 'go-to-completed-consignment-notes',
		label: 'Hotové nákladní listy',
		icon: <HistoryIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: undefined,
		loading: undefined,
		run: async () => {
			navigate(`/consignment-notes/carriers/${carrierId}/completed`);
		}
	};
};
